import { alpha, Theme } from '@mui/material'

const classes = {
  dropzoneOverlay: (theme: Theme) => ({
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    top: 0,
    left: 0,
    backgroundColor: alpha(theme.palette.primary.dark, 0.5),
    backdropFilter: 'blur(10px)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  dropzone: (theme: Theme) => ({
    border: `1px dashed ${theme.palette.text.onPrimary}`,
    borderRadius: '24px',
    backgroundColor: alpha(theme.palette.primary.light, 0.3),
    boxShadow: `0 0 20px 5px ${alpha(theme.palette.primary.light, 0.3)}`,
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    padding: 4,
    margin: 2,
    height: '50%',
  }),
  dropzoneIcon: {
    fontSize: '42px',
  },
  dropzoneText: {
    textAlign: 'center',
  },
  cropperContainer: {
    position: 'relative',
    height: '300px',
    width: '300px',
    margin: '0 auto',
  },
}

export default classes
